export const siteInfo = {
  name: "瓜友会网",
  slogan: "有料你就来，真相值得被看见",
  tagline: "匿名爆料 · 线索征集 · 独家消息",
  description:
    "瓜友会网是一个面向中文互联网的匿名爆料与投稿社区。我们全天候接收线索，从核实到发布全程保护投稿者隐私，让手里有料却不敢开口的人，也能安心把真相交出去。",
  email: "tougao@guayouhui.com",
  workTime: "投稿通道 24 小时开放，编辑核实时间 09:00 - 23:00",
  founded: "2021 年成立",
};

export const heroStats = [
  { value: "128,436", label: "累计收到投稿", unit: "条" },
  { value: "9,872", label: "已核实发布", unit: "篇" },
  { value: "24", label: "投稿通道在线", unit: "小时" },
  { value: "98.6", label: "投稿者隐私零泄露", unit: "%" },
];

export const tickerWords = [
  "顶流复出专辑进入收尾阶段",
  "头部主播带货翻车后续",
  "新锐饮品品牌拖欠货款",
  "大厂中层奖金池风波",
  "高校奖学金名单被质疑",
  "MCN 解约潮合同条款",
  "融资发布会后的追问",
  "经纪公司两套通稿",
];

export const submitSteps = [
  {
    seq: "01",
    title: "提交线索",
    desc: "通过匿名投稿入口填写基本信息，可以只写一段话、一张截图，也可以附上整理好的完整材料。",
    icon: "ri-send-plane-line",
  },
  {
    seq: "02",
    title: "编辑核实",
    desc: "编辑部会在保护来源的前提下交叉核对时间、地点与关键人物，必要时通过站内通道向你补充提问。",
    icon: "ri-file-search-line",
  },
  {
    seq: "03",
    title: "匿名整理",
    desc: "对外发布时会抹去一切可能指向投稿者的细节，包括截图水印、聊天记录头像与表述习惯。",
    icon: "ri-user-forbid-line",
  },
  {
    seq: "04",
    title: "上墙发布",
    desc: "稿件进入热瓜榜或独家消息栏目，你的线索会被更多人看到，而你的身份始终留在幕后。",
    icon: "ri-fire-line",
  },
];

export const faqs = [
  {
    q: "投稿之后，我的身份会被公开吗？",
    a: "不会。投稿入口不要求实名，也不强制填写联系方式。发布前我们会做一轮去标识化处理，凡是可能指向投稿者本人的细节都会被替换或模糊化，包括截图中的水印、聊天头像、以及带有个人习惯的措辞。",
  },
  {
    q: "投出去的线索多久能收到回复？",
    a: "编辑团队会在收到投稿后的 48 小时内完成第一轮初筛。如果线索需要补充信息，我们会通过你留下的联系方式（选填）联系你；如果初筛后判断暂不适合发布，也会尽量给出简短说明。",
  },
  {
    q: "哪些内容不会发布？",
    a: "涉及未成年人隐私、未经证实的私人住址与家庭成员信息、明显的商业诋毁、以及只有情绪没有事实依据的内容，都不会进入发布流程。我们希望传递的是可被核实的信息，而不是情绪本身。",
  },
  {
    q: "可以只提供图片、录音或视频吗？",
    a: "可以。文字不是必需的，图片、录音、视频、聊天记录截图都可以作为线索提交。建议在描述里简单说明拍摄或录制的时间与大致场景，这能大幅提高线索被采纳的概率。",
  },
  {
    q: "投稿之后还能撤回吗？",
    a: "可以。只要稿件还没有进入排期发布，你都可以通过原投稿通道申请撤回。已经进入编辑流程的稿件，我们会暂停处理并等待你的确认，不会擅自发布。",
  },
  {
    q: "投稿会不会被收费，或者有稿酬？",
    a: "投稿与阅读都不收取任何费用。对于提供了关键独家信息、并愿意配合核实的投稿者，我们会在保护隐私的前提下发放线索奖励，具体以编辑沟通为准。",
  },
];

export const testimonials = [
  {
    name: "匿名瓜友 · 阿柚",
    role: "前互联网从业者",
    avatar: "ri-user-star-line",
    content:
      "之前一直犹豫要不要把手里那份材料交出去，怕被顺藤摸瓜。投完之后编辑只问了两个必要问题，发布版本把我关心的细节全都处理掉了，这点确实靠谱。",
  },
  {
    name: "匿名瓜友 · 老K",
    role: "自由摄影师",
    avatar: "ri-camera-lens-line",
    content:
      "我是随手拍到的现场，本来没打算发。看流程只要填一段描述就行，就顺手投了。第三天在热瓜榜上看到，配图做了模糊处理，来源完全看不出来。",
  },
  {
    name: "匿名瓜友 · 小满",
    role: "在校学生",
    avatar: "ri-book-open-line",
    content:
      "学生的瓜最容易牵连到自己，所以我特别在意匿名这件事。投稿入口连手机号都不强制填，这点让我比较放心。",
  },
  {
    name: "匿名瓜友 · 树洞先生",
    role: "企业法务",
    avatar: "ri-scales-3-line",
    content:
      "我比较挑，只投过两次。两次都能感觉到编辑在认真做交叉核对，宁可慢一点也没有急着发，这种节奏在八卦站里挺难得。",
  },
];

export const contentPrinciples = [
  {
    title: "可核实优先",
    desc: "宁愿晚发一天，也不发一条无法交叉验证的消息。所有上墙内容至少经过两条独立信息源的比对。",
    icon: "ri-checkbox-circle-line",
  },
  {
    title: "来源不可追溯",
    desc: "对外内容中不出现投稿者身份线索。截图统一重制，聊天记录统一替换头像与昵称，表述统一改写。",
    icon: "ri-fingerprint-line",
  },
  {
    title: "不碰红线",
    desc: "未成年人隐私、私人住址、无依据的商业诋毁与人身攻击，一律不进入编辑流程。",
    icon: "ri-shield-check-line",
  },
  {
    title: "纠错机制",
    desc: "发布内容如经证伪，我们会在原文位置追加更正说明，不悄悄删除，也不装作没发生过。",
    icon: "ri-refresh-line",
  },
];

export const hotWords = [
  "复出专辑",
  "直播翻车",
  "拖欠货款",
  "奖金池",
  "奖学金名单",
  "解约条款",
  "两套通稿",
  "融资追问",
  "深夜录音棚",
  "贴牌库存",
];